import React, { useEffect, useState } from 'react'
import { graphql, compose, withApollo } from 'react-apollo'
import { Constants } from '@sukiai/components'
import {
  SET_AGENT_SIZE,
  SET_AGENT_POSITION
} from '../../apollo/actions'
import Schedule from './Schedule'
import PatientsList from './PatientsList'
import get from 'lodash/get'
import seshSto from '../../config/seshSto'
import { SESH_STO } from '../../lib'
import { useLocation } from 'react-router'

import { setPatientListTask } from '../../helpers/gettingStarted.helpers'

const { AGENT } = Constants

export const MODES = {
  SCHEDULE: 'SCHEDULE',
  PATIENTS_LIST: 'PATIENTS_LIST'
}

const shouldShowFullTabs = () => {
  // returning true returns both schedule & patient tabs
  return get(seshSto.session(SESH_STO.CURRENT_ORGANIZATION), 'emr.secondaryType') !== 'EPIC_EMR'
}

const SchedulePatientContainer = (props) => {
  const showFull = shouldShowFullTabs()

  const location = useLocation()
  const [mode, setMode] = useState(location.state?.initalMode || MODES.SCHEDULE)

  useEffect(() => {
    const {
      setAgentPosition,
      setAgentSize
    } = props
    setAgentPosition(AGENT.POSITION.MIDDLE_LEFT)
    setAgentSize(AGENT.SIZE.LARGE)
    setPatientListTask()
  }, [])

  const onModeChange = (newMode) => {
    setMode(newMode)
  }

  if (mode === MODES.PATIENTS_LIST && showFull) {
    return <PatientsList handleModeChange={onModeChange} />
  } else {
    return <Schedule handleModeChange={onModeChange} showFullTabs={showFull} />
  }
}

export default compose(
  withApollo,
  graphql(SET_AGENT_SIZE, {
    props: ({ mutate }) => ({
      setAgentSize: (agentSize) =>
        mutate({
          variables: { agentSize }
        })
    })
  }),
  graphql(SET_AGENT_POSITION, {
    props: ({ mutate }) => ({
      setAgentPosition: (agentPosition) =>
        mutate({
          variables: { agentPosition }
        })
    })
  })
)(SchedulePatientContainer)
